import http from "../http-common";

class MapRuleBasedService {
  getmap_rule_baseds() {
    return http.get('/map_rule_based');
  }
  checkintb(name) {
    return http.get('/map_rule_based/checkintb?name='+name);
  }
  getmap_rule_based(id) {
    return http.get('/map_rule_based/'+id);
  }
  getallrulebased() {
    return http.get('/map_rule_based/getallrulebased');
  }
  findadanduser(ad_id,user) {
    return http.get('/map_rule_based/findadanduser?ad_id='+ad_id+'&&user='+user);
  }
  createmap_rule_based(data) {
    return http.post('/map_rule_based', data);
  } 
  createtestresult(data) {
    return http.post('/testresult', data);
  } 
  deletetestresult(id) {
    return http.delete('/testresult/'+id);
  } 
  createproduct_token(data) {
    return http.post('/product_token', data);
  } 
  getproduct_token(data) {
    return http.post('/product_token/getproduct', data);
  } 
  gettestproduct(data) {
    return http.post('/product_token/gettestproduct', data);
  }
  rulebasedexpert(data) {
    return http.post('/product_token/rulebasedexpert', data);
  } 
  getproductresult(data) {
    return http.post('/product_token/getproductresult', data);
  } 
  getproducttest(data) {
    return http.post('/product_token/getproducttest', data);
  } 
  getproducttestreal(data) {
    return http.post('/product_token/getproducttestreal', data);
  } 
  
  getevaluatereal(data) {
    return http.post('/product_token/getevaluatereal', data);
  }
  getproductsevaluate(data) {
    return http.post('/product_token/getevaluate', data);
  }
  
  getevaluateexceptrulebasereal(data) {
    return http.post('/product_token/getevaluateexceptrulebasereal', data);
  }
  getevaluateexceptrulebase(data) {
    return http.post('/product_token/getevaluateexceptrulebase', data);
  }
  getrulebaseevaluate(data) {
    return http.post('/product_token/getrulebaseevaluate', data);
  }
  getproductkeyword(data) {
    return http.post('/product_token/getproductkeyword', data);
  }
  getmapproducttest(data) {
    return http.post('/product_token/getmapproducttest', data);
  } 
  getmapproduct(data) {
    return http.post('/product_token/getmapproduct', data);
  } 
  getbestrulebased(data) {
    return http.post('/product_token/getbestrulebased', data);
  }
  updateadvertise(id,data) {
    return http.put(`/advertise/${id}`, data);
  }
  updatemap(id,data) {
    return http.put(`/product_token/updatemap/${id}`, data);
  }
  updatproduct_token(id,data) {
    return http.put(`/product_token/${id}`, data);
  }
  updatelinkurl(id,data) {
    return http.put(`/product_token/updatelinkurl/${id}`, data);
  }
  updaterulebased(id,data) {
    return http.put(`/advertise/updaterulebased/${id}`, data);
  }
  updateanswer(id,data) {
    return http.put(`/map_rule_based/updateanswer/${id}`, data);
  }
  updatemap_rule_based(id,data) {
    return http.put(`/map_rule_based/${id}`, data);
  }
  updateweight(id,data) {
    return http.put(`/map_rule_based/updateweight/${id}`, data);
  }
  deletemap_rule_based(id,data) {
    return http.put(`/map_rule_based/updatestatus/${id}`, data);
  }
}

export default new MapRuleBasedService();

